export const ROUTERS = {
  LOGIN: "/login",
  USER_REGISTER: "/user-registration",
  PHOTOGRAPHING_DOCUMENT: "/photographing-document",
  APPROVE: "/approve",
  SUPPERLIER_SCREEN_INPUT_FORM: "/supplier-screen-input-form",
  USER_MANAGEMENT: "/user-management",
  CONFIRM_EMAIL: "/confirm-email",
  RESET_PASSWORD: "/reset-password",
  DETAIL_FORM: "/detail-form",
  ORGANIZATION_LIST: "/organization-list",
  SERVICE_MANAGEMENT: "/service",
  NOTIFICATION_SETTING: "/notification-setting",
  CONFIRM_CHANGE_EMAIL: "/confirm-change-email",
  DENSHI: "/denshi",
  TOKUBAI: "/tokubaiassist",
  BIDASHBOARD: "/bidashboard",
  FORECAST: "/uriageyosoku",
  INTRANET: "/intranet",
  ECM: "/ecm",
  NEBIKI: "/nebiki",
  BAKERY: "/bakery",
  DASHBOARD: "/dashboard",
  TASK_LIST: "/task-list",
  CONFIRM_EMAIL_CODE: "/verify",
  CONFIRM_TEMPORARY_REQUEST_DETAIL: "/confirm-temporary-request-detail",
  MAIL_NOT_FOUND: "/mail-not-found",
  LINK_MANAGEMENT: "/link-management",
  USER_REGISTER_VENDOR: "/user-register-vendor",
};
